import React, { useState, useEffect } from 'react';
import HomeSecond from '../HomeSecond/HomeSecond';
import HomeSlider from '../HomeSlider/HomeSlider';
import Asm from '../Asm/Asm';
import Archetype from '../Archetype/Archetype';
import Popularity from '../Popularity/Popularity';
import Testimonial from '../Testimonial/Testimonial';
import axios from 'axios';
import { END_URL, IMG_URL } from "../../config";
import { Helmet } from 'react-helmet';
import HomeSocialMedia from '../HomeSocialMedia/HomeSocialMedia';

const CACHE_KEY = "home_page_cache_v1";

function Home({free_test_slug}) {

    const [home, setHome] = useState([]);
    // const [Model, setModel] = useState([]);
    // const [archetype, setarchetype] = useState([]);
    const [seo, setSeo] = useState({});
    
    const asm_page = false;  

      useEffect(() => {

        const cachedData = localStorage.getItem(CACHE_KEY);

        if (cachedData) {
            const parsed = JSON.parse(cachedData);

            setHome(parsed.home || []);
            // setModel(parsed.model || []);
            // setarchetype(parsed.archetype || []);
            setSeo(parsed.seo || {});
        }

        fetchHomeData();

    }, []);


    const fetchHomeData = async () => {
        try {
            const response = await axios.get(`${END_URL}/home`);

            const {
                data: responseData,
                // model: modelData,
                // archetype: archetypeData,
                seo_page: seoData,
                updated_at
            } = response.data;

            const newPayload = {
                home: responseData || {},
                // model: modelData || [],
                // archetype: archetypeData || [],
                seo: seoData || {},
                updated_at: updated_at || new Date().getTime()
            };

            const cachedData = localStorage.getItem(CACHE_KEY);

            if (cachedData) {
                const parsedCache = JSON.parse(cachedData);

                const isDifferent =
                    JSON.stringify(parsedCache.home) !== JSON.stringify(newPayload.home) ||
                    JSON.stringify(parsedCache.seo) !== JSON.stringify(newPayload.seo);

                if (!isDifferent) {
                    return; 
                }
            }

            setHome(newPayload.home);

            setSeo(newPayload.seo);

            localStorage.setItem(CACHE_KEY, JSON.stringify(newPayload));

        } catch (error) {
            console.error("Error fetching home data:", error);
        }
    };

    return ( 
        <>
            <Helmet>
                <title>{seo?.meta_title || 'PersonalityTest - Discover Your True Archetype | Personality Peek'}</title>

                <meta name="description" content={seo?.meta_description || 'Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey.'} />

                <meta name="keywords" content={seo?.meta_keywords || 'personality assessment test , personality test'} />
                
                <link rel="preload"   fetchpriority="high"  as="image" type="image/webp" href={`${IMG_URL}/d0/${home?.image}`} />

                <link rel="preload"   fetchpriority="high"  as="image" type="image/webp" href={`${IMG_URL}/d0/${home?.previewimage}`} />

                {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
                {seo?.og_description && <meta property="og:description" content={seo.og_description} />}
                {seo?.og_image && <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />}
                {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
                {seo?.og_type && <meta property="og:type" content={seo.og_type} />}

                {seo?.twitter_title && <meta name="twitter:title" content={seo.twitter_title} />}
                {seo?.twitter_description && <meta name="twitter:description" content={seo.twitter_description} />}
                {seo?.twitter_image && <meta name="twitter:image" content={`${IMG_URL}/d0/${seo.twitter_image}`} />}
                {seo?.twitter_card && <meta name="twitter:card" content={seo.twitter_card} />}

                {seo?.og_url && <link rel="canonical" href={seo.og_url} />}

                {!seo?.og_title && <meta property="og:title" content="PersonalityTest - Discover Your True Archetype | Personality Peek" />}
                {!seo?.og_description && <meta property="og:description" content="Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey." />}
                {!seo?.og_type && <meta property="og:type" content="website" />}
                {!seo?.twitter_card && <meta name="twitter:card" content="summary_large_image" />}

                <link rel="preload" as="image" href={`${IMG_URL}/d0/${seo?.insight_image}`} />
        
                <link rel="preload" as="image" href={`${IMG_URL}/d0/${seo?.core_image}`} />
        
            </Helmet>

            <div>
                {/* {hasHomeData && ( */}
                    <>
                        <HomeSlider HomeBanner={home}  />
                              {/* <HomeSocialMedia /> */}
                        <HomeSecond HomeBanner={home} />
                    </>
                {/* )} */}
   
                {/* {hasHomeData && (
                    <>
              
                        <Asm data={home} archetype={archetype} asm_page={asm_page} />
                        <Archetype data={home} />
                        <Testimonial data={home} free_test_slug={free_test_slug} />
                        <Popularity data={home} />
                    </>
                )} */}
            </div>      
        </>
    );
}

export default React.memo(Home);